module.exports = {"sorry":"Sorry, something went wrong.","tryagain":"Try reloading"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/en-US/strings.json
// module id = 1181
// module chunks = 0